const defaultState = [];

export const tracking = (state = defaultState, action) => {
  return state;
};
